module.exports = __webpack_public_path__ + "static/media/vi.33b89abf.webp";